<template>
    <div>
        <div class="err-text" v-if="errorMsg">
            {{ errorMsg }}
        </div>
        <div class="form-sub-title" :class="{'has-error': errorMsg}" v-if="text && !isPc">
            <div v-html="filterXSS(text)" @click="copyText"></div>
        </div>
    </div>
</template>
<script>
import { setClipBoard } from '../../../utils/bridge/webview';
import { getUrlParam } from '../../../utils/url';
import { filterXSS } from '../../../utils';

export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        errorMsg: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isPc: getUrlParam('isPc'),
        };
    },
    methods: {
        filterXSS(html) {
            return filterXSS(html);
        },
        copyText(event) {
            const target = event.target;
            if (target.tagName === 'A' && target.href) {
                event.stopPropagation();
                event.preventDefault();
                setClipBoard(target.href);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.form-sub-title {
    color: var(--font-notice, #9C9C9C);
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-top: 4px;
    /deep/ p {
        line-height: 18px !important;
        font-size: 12px !important;
        color: var(--font-notice, #9C9C9C)!important;
        margin: 0 !important;
    }
    /deep/ a {
        position: relative;
        margin-left: 4px;
        line-height: 18px;
        font-size: 12px;
        margin-right: 18px;
        color: #385080;
        &::after {
            content: "";
            position: absolute;
            width: 17px;
            height: 17px;
            transform: scale(0.83);
            background-image: var(--csc-collect-copy-icon);
            background-size: cover;
          }
    }
}
.has-error {
    margin-top: 4px;
}
.err-text {
    color: #FE3666!important;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 1px;
    /* 设置文本行数 */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    /* 超出部分显示省略号 */
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
